import React, {Component} from 'react'
import {connect} from 'react-redux'
import {asyncError} from 'store/actions/asyncError'
import withRouterLegacy from 'withRouterLegacy'
import {PreviewProcedurePdfModal} from 'components/modals/PreviewProcedurePdfModal'
import {get, groupBy, omit} from 'lodash'
import enroll from 'procedureStatuses/reportList/enroll'
import resign from 'procedureStatuses/reportList/resign'
import changeAddress from 'procedureStatuses/reportList/changeAddress'
import changeName from 'procedureStatuses/reportList/changeName'
import addDependents from 'procedureStatuses/reportList/addDependents'
import removeDependents from 'procedureStatuses/reportList/removeDependents'
import startMaternity from 'procedureStatuses/reportList/startMaternity'
import extendMaternity from 'procedureStatuses/reportList/extendMaternity'
import finishMaternity from 'procedureStatuses/reportList/finishMaternity'
import changeOffice from './reportList/changeOffice'
import startChildcare from './reportList/startChildcare'
import extendChildcare from './reportList/extendChildcare'
import finishChildcare from './reportList/finishChildcare'
import parentalLeave from './reportList/parentalLeave'
import additionalChildcareLeaveAllowance from './reportList/additionalChildcareLeaveAllowance'
import parentalLeaveSupportAllowance from './reportList/parentalLeaveSupportAllowance'
import healthInsuranceQualificationConfirmation from './reportList/healthInsuranceQualificationConfirmation'
import {
  HEALTH_AND_WELFARE_PENSION,
  EMPLOYMENT,
  OTHER,
  toggle,
  Report,
  menuItems,
} from 'procedureStatuses/reportList/common'
import {Link} from 'react-router-dom'
import ListGroup from 'jbc-front/components/ListGroup'
import {Panel, Headding} from 'components/SecondaryPanel'
import DropDownMenu from 'components/DropDownMenu'
import UploadRequest from 'procedureStatuses/UploadRequest'
import {makeBackUrl, recordDisplay} from 'utils'
import {getMainOfficeContactInfo} from 'offices/utils'

const procedures = {
  enroll,
  resign,
  change_address: changeAddress,
  change_name: changeName,
  add_dependents: addDependents,
  remove_dependents: removeDependents,
  start_maternity: startMaternity,
  extend_maternity: extendMaternity,
  finish_maternity: finishMaternity,
  change_office: changeOffice,
  start_childcare: startChildcare,
  extend_childcare: extendChildcare,
  finish_childcare: finishChildcare,
  parental_leave: parentalLeave,
  additional_childcare_leave_allowance: additionalChildcareLeaveAllowance,
  parental_leave_support_allowance: parentalLeaveSupportAllowance,
  health_insurance_qualification_confirmation: healthInsuranceQualificationConfirmation,
}

const mapReport = (infos, handleClick) => (report, index) => (
  <Report
    onClick={handleClick}
    edit={report.editable ? infos.procedureStatus.status === 'in_progress' : null}
    key={index}
    {...omit(report, ['type', 'editable'])}
  />
)

class ReportList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      previewPdfData: null,
    }
  }

  getUrl = (params) => {
    const {dependentId, num} = params
    let pdfUrl = `/api/procedure_statuses/${this.props.procedureStatus.id}/pdf?type=${num}`
    if (dependentId) {
      pdfUrl += `&employee_dependent_id=${dependentId}`
    }
    return pdfUrl
  }

  showPreviewPdf = (params) => {
    const {
      procedureStatus: {id},
    } = this.props
    const pdfUrl = this.getUrl(params)
    this.setState({
      previewPdfData: {
        ...params,
        url: pdfUrl,
        pdf: pdfUrl,
        procedureStatusId: id,
      },
    })
  }

  handleClosePreviewPdf = () => {
    this.setState({previewPdfData: null})
  }

  render() {
    const {currentOffice, procedureStatus, location, title, onAsyncError} = this.props
    const healthInsuranceType = get(procedureStatus, 'employee.office.health_insurance_type')
    const healthInsuranceJoined = get(procedureStatus, 'employee.health_insurance.joined')
    const welfarePensionInsuranceJoined = get(procedureStatus, 'employee.welfare_pension_insurance.joined')
    const employmentInsuranceJoined = get(procedureStatus, 'employee.employment_insurance.joined')
    const employee = procedureStatus.employee
    const employeeFullName = employee.display_full_name
    const mainOfficeSocial = getMainOfficeContactInfo(currentOffice)
    const infos = {
      procedureStatus,
      healthInsuranceType,
      healthInsuranceJoined,
      welfarePensionInsuranceJoined,
      employmentInsuranceJoined,
    }
    const reportList = [...procedures[procedureStatus.procedure_type].getReportList(infos)]
    const reportGroups = groupBy(reportList, 'type')
    const ProcedureInfo = procedures[procedureStatus.procedure_type].ProcedureInfo
    return (
      <React.Fragment>
        <Panel>
          {reportList.length > 0 ? (
            <DropDownMenu
              toggle={toggle}
              menuItems={menuItems(
                reportList.map((report) => ({
                  url: this.getUrl(report),
                  title: report.title,
                })),
                title,
                onAsyncError
              )}
            />
          ) : (
            toggle({})
          )}
          {reportGroups[HEALTH_AND_WELFARE_PENSION] && (
            <ListGroup>
              <ListGroup.Title>社会保険</ListGroup.Title>
              {reportGroups[HEALTH_AND_WELFARE_PENSION].map(mapReport(infos, this.showPreviewPdf))}
            </ListGroup>
          )}
          {reportGroups[EMPLOYMENT] && (
            <ListGroup>
              <ListGroup.Title>雇用保険</ListGroup.Title>
              {reportGroups[EMPLOYMENT].map(mapReport(infos, this.showPreviewPdf))}
            </ListGroup>
          )}
          {reportGroups[OTHER] && (
            <ListGroup>
              <ListGroup.Title>その他</ListGroup.Title>
              {reportGroups[OTHER].map(mapReport(infos, this.showPreviewPdf))}
            </ListGroup>
          )}
          <UploadRequest {...{reportList, procedureStatus}} />
        </Panel>
        <Panel>
          <Headding>関連データ</Headding>
          <ListGroup>
            <ListGroup.Title>事業所情報</ListGroup.Title>
            <ListGroup.Item as={Link} to="/client">
              {recordDisplay(mainOfficeSocial.name)}
            </ListGroup.Item>
          </ListGroup>
          <ListGroup>
            <ListGroup.Title>従業員情報</ListGroup.Title>
            <ListGroup.Item
              as={Link}
              to={`/employees/${procedureStatus.employee_id}/edit?back_to=${makeBackUrl(location)}`}
            >
              {employeeFullName}
            </ListGroup.Item>
            {procedureStatus.procedure_type === 'change_office' && (
              <ListGroup.Item
                as={Link}
                to={`/employees/${procedureStatus.employee_id}/personnel_history?back_to=${makeBackUrl(location)}`}
              >
                人事異動履歴一覧
              </ListGroup.Item>
            )}
          </ListGroup>
          <ProcedureInfo procedureStatus={procedureStatus} />
        </Panel>
        <PreviewProcedurePdfModal
          data={this.state.previewPdfData}
          procedureStatus={{
            procedureType: procedureStatus.procedure_type,
            employeeId: procedureStatus.employee_id,
            healthInsuranceType: healthInsuranceType,
            isRelatedRecordsDirty: procedureStatus.is_related_records_dirty,
          }}
          onClose={this.handleClosePreviewPdf}
        />
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  procedureStatus: state.procedureStatuses.current.data,
  currentUser: state.session.currentUser,
  currentOffice: state.client.current.office,
  token: state.auth.token,
})

export default withRouterLegacy(
  connect(mapStateToProps, (dispatch) => ({
    onAsyncError(err) {
      dispatch(asyncError(err))
    },
  }))(ReportList)
)
